<template>
    <common-modal>
        <common-content-wrapper width="huge" class="slot-days">
            <common-content-spacer height="small">
                <h3 class="slot-days__heading">{{ $t('components.availability.add_availability.modal.heading') }}</h3>
                <div class="slot-days__checkbox">
                    <div v-for="(slots, day) in days" :key="day" class="slot-days__checkbox-div">
                        <checkbox-input
                            :label="$t(`common.days.${day}.short`)"
                            :hasBigTapArea="true"
                            :isDisabled="isDisabled(day)"
                            :value="isCheckboxChecked(day)"
                            @change="checkboxChanged(day)"
                        ></checkbox-input>
                    </div>
                </div>
                <common-buttons>
                    <common-button
                        type="secondary"
                        :label="$t('common.microcopy.false')"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button
                        type="primary"
                        :label="$t('common.microcopy.apply')"
                        @click="emitEvent({ name: 'success', payload: checkedDays })"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    import CheckboxInput from 'components/form-inputs/CheckboxInput'

    export default {
        components: {
            CheckboxInput,
        },
        props: {
            days: { type: Array, required: true },
            selectedDay: { type: String, required: true },
        },

        data() {
            return {
                checkedDays: [this.selectedDay],
            }
        },

        methods: {
            isDisabled(day) {
                return this.selectedDay === day
            },
            isCheckboxChecked(day) {
                return this.checkedDays.includes(day)
            },

            checkboxChanged(day) {
                const index = this.checkedDays.indexOf(day)
                if (index > -1) {
                    this.checkedDays.splice(index, 1)
                } else {
                    this.checkedDays.push(day)
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    .slot-days {
        @include breakpoint(smartphone-large) {
            margin-top: 30px;
        }
        &__heading {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: $font-size--heading-small;
            text-align: center;
        }
        &__checkbox {
            flex-wrap: wrap;
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin-bottom: 40px;

            &-div {
                margin: 10px 5px;
                @include breakpoint(smartphone-large) {
                    margin: 10px 10px;
                }
            }
        }
    }
</style>
